import React from 'react';
import { RotateCcw, ZoomIn } from 'lucide-react';

/**
 * Shared in-flow header row for every zoomable chart panel on the site: an optional
 * left-aligned caption, and a persistent "Drag to zoom" hint + conditional "Reset Zoom"
 * button on the right. Always occupies real layout space (never `position: absolute`) so
 * it can't overlap the chart's own axes/gridlines below it — a real bug hit once on
 * Battery Energy Consumption when the button was absolutely positioned over a chart with
 * no caption to share space with.
 *
 * Pair with useChartZoom() — this component is presentation-only, the hook owns the state.
 * This is the standard pairing for every zoomable chart on the site (see that hook's own
 * docstring for scope/exclusions).
 */
const ChartZoomHeader = ({ caption, isZoomed, onReset, testId }) => (
  <div className="flex items-center justify-between gap-3 mb-1">
    {caption ? (
      <p className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground truncate">{caption}</p>
    ) : (
      <span />
    )}
    <div className="flex items-center gap-3 shrink-0">
      <span className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-wider text-muted-foreground/60 whitespace-nowrap">
        <ZoomIn className="h-3 w-3" /> Drag to zoom
      </span>
      {isZoomed && (
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-wider text-autoxium-blue hover:underline whitespace-nowrap"
          data-testid={testId}
        >
          <RotateCcw className="h-3 w-3" /> Reset Zoom
        </button>
      )}
    </div>
  </div>
);

export default ChartZoomHeader;
